import ClientConfigServices from "../../../../../Services/ClientConfigServices.js";
import FileDownloadServices from "../../../../../Services/FileDownloadServices.js";
import axios from "axios";

const addVendor = async (inputData, toast, getData) => {
  try {
    let response = await ClientConfigServices.addVendor(inputData);
    if (response.status === 201) {
      toast.success(response.data.message);
      getData();
      return { success: true };
    }
    // Handle unexpected success status codes
    toast.error(`Unexpected response status: ${response.status}`);
    return { success: false, error: "unexpected_status" };
  } catch (e) {
    // Check for validation errors from backend
    if (axios.isAxiosError(e) && e.response?.status === 409) {
      const data = e.response.data;
      if (data.error_code === "exact_match") {
        toast.error(data.message || "Customer name already exists");
        return { success: false, error: "exact_match" };
      }
    }
    toast.error("An error occurred while creating the customer");
    return { success: false, error: "unknown" };
  }
};

const updateVendor = async (vendorId, inputData, toast, getData) => {
  try {
    let response = await ClientConfigServices.editVendor(vendorId, inputData);
    if (response.status === 200) {
      toast.success(response.data.message);
      if (getData) getData();
      return { success: true };
    }
    // Handle unexpected success status codes
    toast.error(`Unexpected response status: ${response.status}`);
    return { success: false, error: "unexpected_status" };
  } catch (e) {
    // Check for validation errors from backend
    if (axios.isAxiosError(e) && e.response?.status === 409) {
      const data = e.response.data;
      if (data.error_code === "exact_match") {
        toast.error(data.message || "Customer name already exists");
        return { success: false, error: "exact_match" };
      }
    }
    toast.error("An error occurred while updating the customer");
    return { success: false, error: "unknown" };
  }
};

const exportVendors = async setExportLoader => {
  setExportLoader(true);
  try {
    let response = await ClientConfigServices.exportVendors();
    if (response.status === 200) {
      FileDownloadServices.downloadFile(response, "vendors", "csv");
    }
  } catch (e) {}
  setExportLoader(false);
};

export { addVendor, updateVendor, exportVendors };
